import axios from "axios";
import { getToken } from "../utils/auth";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_API_URL = `${BASE_URL}/api`;
const SOCKET_URL = process.env.REACT_APP_BASE_URL;

let socket = null;

// Safe socket initialization only in browser environment
(async () => {
  if (typeof window !== "undefined") {
    const { io } = await import("socket.io-client");
    socket = io(SOCKET_URL, {
      reconnectionAttempts: 5,
      timeout: 5000,
      withCredentials: true,
    });

    socket.on("connect", () => {
      console.log("WebSocket connected:", socket.id);
    });

    socket.on("newRideRequest", (rideData) =>
      console.log("New ride request:", rideData)
    );
    socket.on("rideAccepted", ({ rideId, driverId }) =>
      console.log(`Ride ${rideId} accepted by Driver ${driverId}`)
    );
    socket.on("driverStatusUpdated", ({ driverId, status }) =>
      console.log(`Driver ${driverId} is now ${status}`)
    );
    socket.on("disconnect", () => {
      console.log("WebSocket disconnected");
    });
  }
})();

// Helper Function for API Requests

// const apiRequest = async (method, endpoint, data = null) => {
//   try {
//     const response = await axios({
//       method,
//       url: `${BASE_API_URL}${endpoint}`,
//       data,
//     });

//     console.log("responsasase = ", response);
//     return response.data;
//   } catch (error) {
//     console.error(
//       `API Error [${method.toUpperCase()} ${endpoint}]:`,
//       error.response?.data || error
//     );
//     return { error: error.response?.data || "Request failed" };
//   }
// };

export const apiRequest = async (method, endpoint, data = null) => {
  const token = getToken();

  try {
    const response = await axios({
      method,
      url: `${BASE_API_URL}${endpoint}`,
      data,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      `API Error [${method.toUpperCase()} ${endpoint}]:`,
      error.response?.data || error.message || error
    );
    return { error: error.response?.data || error.message || "Request failed" };
  }
};
// Book a Ride & Notify Drivers
export const bookRide = async (
  userId,
  fromLocation,
  toLocation,
  vehicleType,
  rideType = "Regular",
  durationInMinutes,
  reqName,
  reqMobileNo
) => {
  if (!userId) return { error: "Invalid User ID" };
  console.log("book ride req data = ", reqName, " ", reqMobileNo);
  const response = await apiRequest("post", "/bookings/book-ride", {
    userId,
    fromLocation,
    toLocation,
    vehicleType,
    rideType,
    durationInMinutes,
    reqName,
    reqMobileNo,
  });

  console.log("bookride resp = ", response);

  if (response?.rideId && socket) {
    socket.emit("newRideRequest", {
      RIDE_ID: response.rideId,
      FROM_LOCATION: fromLocation,
      TO_LOCATION: toLocation,
      IS_SPECIAL_TASK: rideType === "Special Task",
      DURATION_IN_MINUTES: durationInMinutes,
      REQUESTER_NAME: response.reqName,
      REQUESTER_MOBILE: response.reqMobileNo,
    });
  }

  return response;
};

// Accept a Ride & Notify Requester
export const acceptRide = async (rideId, driverId) => {
  if (!rideId) return { error: "Invalid parameters" };

  const response = await apiRequest("post", "/tracking/accept-ride", {
    driverId,
    rideId,
  });

  // console.log("accept ride response = ", response);

  if (response.success && socket) {
    socket.emit("rideAccepted", { rideId });
  }

  return response;
};

// Other API functions
export const fetchActiveRide = (userId) =>
  apiRequest("get", `/tracking/ride-status/${userId}`);

export const submitMaintenanceRequest = (requestData) =>
  apiRequest("post", "/requests/maintenanceReq", requestData);

export const updateMaintenanceStatus = (requestId, status, comment = null) =>
  apiRequest("put", `/maintenance/update-status/${requestId}`, {
    status,
    comment,
  });

export const startRide = (rideId) =>
  apiRequest("post", "/tracking/start-ride", { rideId });

export const markPickTime = (rideId) =>
  apiRequest("post", "/tracking/mark-pick-time", { rideId });

export const completeRide = (rideId) =>
  apiRequest("post", "/tracking/complete-ride", { rideId });

export const fetchMaintenanceRequests = () =>
  apiRequest("get", "/maintenance/issues");

export const reportMaintenance = (forkliftId, issue) =>
  apiRequest("post", "/maintenance/report-maintenance", { forkliftId, issue });

export const resolveMaintenance = (requestId) =>
  apiRequest("post", "/maintenance/resolve-maintenance", { requestId });

export const fetchRideReports = () => apiRequest("get", "/reports/rides");

export const markHome = (driverId) =>
  apiRequest("post", "/drivers/mark-home", { driverId });

// export const cancelRide = (rideId) =>
//   apiRequest("delete", `/bookings/cancel/${rideId}`);
